<template>
    <div class="all-cont">
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 版本名称：
            </div>
            <div><Input class="inp-wid" placeholder="请输入版本名称" v-model="formdata.version_name" /></div>
        </div>
        <div class="cont-itsf">
            <div class="title">
                <div class="red-xing">*</div> 简介：
            </div>
            <div>
                <Input
                    class="inp-wid"
                    placeholder="请输入简介"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 5 }"
                    v-model="formdata.description"
                />
            </div>
        </div>
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 版本权限：
            </div>
            <div>
                <Select v-model="formdata.permissions_id" class="inp-wid" placeholder="请选择版本权限">
                    <Option v-for="item in permissionsList" :value="item.id" :key="item.id">
                        {{ item.version_name }}
                    </Option>
                </Select>
            </div>
        </div>
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 版本价格：
            </div>
            <div class="inline-row">
                <Input class="inp-prd" placeholder="请输入版本价格" type="number" v-model="formdata.price" />
                <span class="inline-label">原价：</span>
                <Input class="inp-prd" placeholder="请输入原价" type="number" v-model="formdata.original_price" />
            </div>
        </div>
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 版本授权：
            </div>
            <div class="inline-row">
                <Select v-model="formdata.auth_type" class="inp-prd" @on-change="onAuthTypeChange">
                    <Option v-for="item in authTypeOptions" :value="item.value" :key="item.value">
                        {{ item.label }}
                    </Option>
                </Select>
                <template v-if="isLimitedAuth">
                    <span class="inline-label">授权时间：</span>
                    <Input class="inp-prd" placeholder="请输入" type="number" v-model="formdata.year_num" />
                    <span class="inline-unit">年</span>
                </template>
            </div>
        </div>
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 赠送短信：
            </div>
            <div>
                <Input class="inp-prd" placeholder="请输入数量" type="number" v-model="formdata.gift_sms" />
            </div>
        </div>
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 是否支持更新：
            </div>
            <div>
                <Select v-model="formdata.support_update" class="inp-prd">
                    <Option v-for="item in updateOptions" :value="item.value" :key="item.value">
                        {{ item.label }}
                    </Option>
                </Select>
            </div>
        </div>
        <div class="cont-its">
            <div class="title">
                <div class="red-xing">*</div> 次年费用：
            </div>
            <div class="inline-row">
                <Input class="inp-prd" placeholder="请输入" type="number" v-model="formdata.renewal_fee" />
                <span class="inline-unit">元/年</span>
            </div>
        </div>
        <div class="cont-itsf">
            <div class="title">附加功能：</div>
            <div class="extra-features">
                <CheckboxGroup v-model="formdata.extra_features">
                    <Checkbox v-for="item in extraFeatureOptions" :label="item" :key="item">
                        {{ item }}
                    </Checkbox>
                </CheckboxGroup>
            </div>
        </div>
        <Divider />
        <div class="footer">
            <Button v-throttle type="primary" @click="submit" style="margin-right: 5px">确认</Button>
            <Button style="margin-right: 5px" @click="resetForm">重置</Button>
        </div>
    </div>
</template>

<script>
import { version_update, version_get_list, get_extra_features, version_permission_list } from '@/api/versionPackage'

function createDefaultForm() {
    return {
        id: '',
        version_name: '',
        description: '',
        permissions_id: '',
        price: '',
        original_price: '',
        auth_type: 1,
        year_num: '',
        gift_sms: '',
        support_update: 1,
        renewal_fee: '',
        extra_features: []
    }
}

export default {
    name: 'versionPackageInfo',
    beforeRouteEnter(to, from, next) {
        if (to.query.run === 'add') {
            to.meta.title = '版本套餐 / 创建'
        } else if (to.query.run === 'edit') {
            to.meta.title = '版本套餐 / 编辑'
        }
        next()
    },
    data() {
        return {
            permissionsList: [],
            authTypeOptions: [
                { value: 1, label: '有限' },
                { value: 2, label: '终生' }
            ],
            updateOptions: [
                { value: 1, label: '更新' },
                { value: 0, label: '不更新' }
            ],
            extraFeatureOptions: [],
            formdata: createDefaultForm()
        }
    },
    computed: {
        isLimitedAuth() {
            return Number(this.formdata.auth_type) === 1
        },
        isPermanent() {
            return Number(this.formdata.auth_type) === 2
        }
    },
    created() {
        this.loadPermissions()
        this.loadExtraFeatures()
        if (this.$route.query.run !== 'add' && this.$route.query.id) {
            this.loadDetail(this.$route.query.id)
        }
    },
    methods: {
        loadPermissions() {
            version_permission_list().then(res => {
                const pageData = (res && res.data) || {}
                this.permissionsList = pageData.data || []
            }).catch(() => {
                this.permissionsList = []
            })
        },
        loadExtraFeatures() {
            get_extra_features().then(res => {
                const list = (res && res.data) || []
                this.extraFeatureOptions = Array.isArray(list) ? list : []
            }).catch(() => {
                this.extraFeatureOptions = []
            })
        },
        loadDetail(id) {
            const cached = sessionStorage.getItem('versionPackageEditRow')
            if (cached) {
                try {
                    const row = JSON.parse(cached)
                    if (String(row.id) === String(id)) {
                        this.fillFormFromRow(row)
                        sessionStorage.removeItem('versionPackageEditRow')
                        return
                    }
                } catch (e) {
                    sessionStorage.removeItem('versionPackageEditRow')
                }
            }
            version_get_list({ page: 1, limit: 500, version_name: '' }).then(res => {
                const list = ((res && res.data) || {}).data || []
                const row = list.find(item => String(item.id) === String(id))
                if (row) {
                    this.fillFormFromRow(row)
                } else {
                    this.$Message.error('未找到版本详情')
                }
            }).catch(res => {
                this.$Message.error((res && res.msg) || '获取版本详情失败')
            })
        },
        fillFormFromRow(data) {
            this.formdata = {
                ...createDefaultForm(),
                id: data.id,
                version_name: data.version_name || '',
                description: data.description || '',
                permissions_id: data.permissions_id,
                price: data.price != null ? String(data.price) : '',
                original_price: data.original_price != null ? String(data.original_price) : '',
                auth_type: Number(data.is_permanent) === 1 ? 2 : 1,
                year_num: data.year_num != null && data.year_num !== '' ? String(data.year_num) : '',
                gift_sms: data.gift_sms != null ? String(data.gift_sms) : '',
                support_update: Number(data.support_update) === 0 ? 0 : 1,
                renewal_fee: data.renewal_fee != null ? String(data.renewal_fee) : '',
                extra_features: this.normalizeExtraFeatures(data.extra_features)
            }
        },
        normalizeExtraFeatures(value) {
            if (Array.isArray(value)) return [...value]
            if (typeof value === 'string' && value.trim()) {
                return value.split(',').map(item => item.trim()).filter(Boolean)
            }
            return []
        },
        onAuthTypeChange() {
            if (!this.isLimitedAuth) {
                this.formdata.year_num = ''
            }
        },
        validateForm() {
            const f = this.formdata
            if (!f.version_name) return this.$Message.error('请填写版本名称'), false
            if (!f.description) return this.$Message.error('请填写简介'), false
            if (f.permissions_id === '' || f.permissions_id === null) return this.$Message.error('请选择版本权限'), false
            if (f.price === '' || f.price === null) return this.$Message.error('请填写版本价格'), false
            if (this.isLimitedAuth && (f.year_num === '' || f.year_num === null)) {
                return this.$Message.error('请填写授权时间'), false
            }
            if (f.gift_sms === '' || f.gift_sms === null) return this.$Message.error('请填写赠送短信数量'), false
            if (f.support_update === '' || f.support_update === null) {
                return this.$Message.error('请选择是否支持更新'), false
            }
            if (f.renewal_fee === '' || f.renewal_fee === null) return this.$Message.error('请填写次年费用'), false
            return true
        },
        buildSubmitPayload() {
            const payload = {
                version_name: this.formdata.version_name,
                description: this.formdata.description,
                permissions_id: this.formdata.permissions_id,
                price: this.formdata.price,
                original_price: this.formdata.original_price,
                renewal_fee: this.formdata.renewal_fee,
                gift_sms: this.formdata.gift_sms,
                is_permanent: this.isPermanent ? 1 : 0,
                year_num: this.isLimitedAuth ? this.formdata.year_num : 0,
                support_update: this.formdata.support_update,
                extra_features: (this.formdata.extra_features || []).join(',')
            }
            if (this.$route.query.run === 'edit' && this.$route.query.id) {
                payload.id = this.$route.query.id
            }
            return payload
        },
        submit() {
            if (!this.validateForm()) return
            version_update(this.buildSubmitPayload()).then(res => {
                this.$Message.success(res.msg)
                this.$router.push({ path: '/admin/versionPackage' })
            }).catch(res => {
                this.$Message.error((res && res.msg) || '保存失败')
            })
        },
        resetForm() {
            this.formdata = createDefaultForm()
        }
    }
}
</script>

<style scoped>
.all-cont {
    width: 100%;
}

.cont-its {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 20px;
}

.cont-itsf {
    display: flex;
    justify-content: flex-start;
    margin-top: 30px;
}

.red-xing {
    color: red;
    margin-right: 5px;
    font-weight: bold;
}

.title {
    display: flex;
    text-align: end;
    justify-content: flex-end;
    width: 120px;
    user-select: none;
    flex-shrink: 0;
}

.footer button {
    width: 65px;
    margin: 0 40px;
}

.inp-wid {
    width: 350px;
}

.inp-prd {
    width: 150px;
    margin-right: 10px;
}

.inline-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.inline-label {
    margin-right: 8px;
    color: #515a6e;
    white-space: nowrap;
}

::v-deep .inp-wid.ivu-select {
    width: 350px;
}

::v-deep .inp-prd.ivu-select {
    width: 150px;
}

.inline-unit {
    color: #515a6e;
}

.extra-features {
    padding-top: 2px;
}

.extra-features ::v-deep .ivu-checkbox-group-item {
    margin-right: 24px;
    margin-bottom: 12px;
}
</style>
